import { ButtonHTMLAttributes, ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

const Button = ({ children, ...props }: ButtonProps) => {
  return (
    <button
      {...props}
      style={{
        boxShadow:
          "0px 2px 5px rgba(60, 66, 87, 0.08), 0px 1px 1px rgba(0, 0, 0, 0.12)",
        ...props.style,
      }}
      className={`cursor-pointer text-sm font-semibold font-['Stabil_Grotesk'] px-2 py-1 rounded-sm border-[1px] leading-5 tracking-normal relative transition-all duration-150 hover:bg-gray-50 active:transform active:translate-y-[1px] active:shadow-none active:bg-gray-100 text-text-primary border-border ${props.className || ""}`}
    >
      {children}
    </button>
  );
};

export default Button;
